<form #intervalsForm="ngForm">
  <hw-flex-editable-table
    #intervalsTable
    header="mdm.obs-def-02.intervals.header"
    [form]="intervalsForm"
    [data]="definition.intervals"
    [rowInstance]="defaultIntervalRow"
    [editMode]="editMode">
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.usage" sort="usage.code">
      <ng-template #viewTemplate let-qualifiedInterval>
        {{ qualifiedInterval.usage?.code | localizedConceptName : 'observation-interval-usage' | async }}
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.interpretation" sort="interpretation.code">
      <ng-template #viewTemplate let-qualifiedInterval>
        {{ qualifiedInterval.interpretation?.code }}
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.range">
      <ng-template #viewTemplate let-qualifiedInterval>
        <hw-abbreviate [value]="qualifiedInterval.range" [length]="50"></hw-abbreviate>
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.names">
      <ng-template #viewTemplate let-qualifiedInterval>
        {{ qualifiedInterval.names | localName }}
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.criteria.gender">
      <ng-template #viewTemplate let-qualifiedInterval>
        {{ qualifiedInterval.criteria?.gender | localizedConceptName : 'administrative-gender' | async }}
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.intervals.criteria.age">
      <ng-template #viewTemplate let-qualifiedInterval>
        {{ qualifiedInterval.criteria?.age?.lower }} - {{ qualifiedInterval.criteria?.age?.upper }}
      </ng-template>
    </hw-flex-editable-column>

    <ng-template #actionsTemplate let-qualifiedInterval let-index="index">
      <a class="action-text" (click)="duplicateInterval(index)">{{
        'mdm.obs-def-02.intervals.duplicate' | translate
      }}</a>
      <nz-divider nzType="vertical"></nz-divider>
      <a
        class="action-text"
        nz-popconfirm
        [nzPopconfirmTitle]="'core.delete-confirm' | translate"
        (nzOnConfirm)="intervalsTable.deleteRow(index)"
        >{{ 'core.btn.delete' | translate }}</a
      >
    </ng-template>

    <ng-template #expandEditTemplate #expandViewTemplate let-qualifiedInterval>
      <ng-container *ngIf="qualifiedInterval">
        <div hw-form-row class="form-row">
          <div *hwFormCol>
            <hw-form-item
              name="qualifiedIntervalUsage"
              label="mdm.obs-def-02.intervals.usage"
              [labelSpan]="24"
              [controlSpan]="24"
              required>
              <hw-term-codesystem-concept-select
                [(ngModel)]="qualifiedInterval.usage"
                (ngModelChange)="qualifiedInterval.interpretation = null"
                name="qualifiedIntervalUsage"
                codesystem="observation-interval-usage"
                valueType="codeName"
                required></hw-term-codesystem-concept-select>
            </hw-form-item>
          </div>

          <div *hwFormCol>
            <hw-form-item
              name="qualifiedIntervalInterpretation"
              label="mdm.obs-def-02.intervals.interpretation"
              [labelSpan]="24"
              [controlSpan]="24"
              required>
              <hw-term-codesystem-concept-select
                [(ngModel)]="qualifiedInterval.interpretation"
                name="qualifiedIntervalInterpretation"
                [codesystem]="
                  (qualifiedInterval.usage?.code | concept : 'observation-interval-usage' | async)?.attributes[
                    'interpretation-codesystem'
                  ]
                "
                display="codeName"
                valueType="codeName"
                [autoSelect]="true"
                required></hw-term-codesystem-concept-select>
            </hw-form-item>
          </div>
        </div>

        <div hw-form-row class="form-row">
          <div *hwFormCol>
            <hw-form-item name="snomed" label="mdm.obs-def-02.intervals.snomed" [labelSpan]="24" [controlSpan]="24">
              <hw-snomed-input [(ngModel)]="qualifiedInterval.snomed" name="snomed"></hw-snomed-input>
            </hw-form-item>
          </div>

          <div *hwFormCol></div>
        </div>

        <div hw-form-row class="form-row" [full]="true">
          <div *hwFormCol>
            <hw-form-item
              name="range"
              label="mdm.obs-def-02.intervals.range"
              [labelSpan]="24"
              [controlSpan]="24"
              required>
              <hw-observation-definition-range-hint
                name="range"
                [(input)]="qualifiedInterval.range"
                [definition]="definition"
                [includeVal]="true"></hw-observation-definition-range-hint>
            </hw-form-item>

            <hw-form-item name="names" label="mdm.obs-def-02.intervals.names" [labelSpan]="24" [controlSpan]="24">
              <hw-multilang-input name="names" [(ngModel)]="qualifiedInterval.names"></hw-multilang-input>
            </hw-form-item>
          </div>
        </div>

        <nz-divider nzOrientation="left" [nzText]="'mdm.obs-def-02.intervals.criteria.header' | translate"></nz-divider>
        <div hw-form-row class="form-row" [full]="true">
          <div *hwFormCol>
            <hw-form-item
              name="gender"
              label="mdm.obs-def-02.intervals.criteria.gender"
              [labelSpan]="24"
              [controlSpan]="24">
              <hw-term-codesystem-concept-select
                name="gender"
                [(ngModel)]="qualifiedInterval.criteria['gender']"
                codesystem="administrative-gender"></hw-term-codesystem-concept-select>
            </hw-form-item>

            <hw-form-item name="age" label="mdm.obs-def-02.intervals.criteria.age" [labelSpan]="24" [controlSpan]="24">
              <hw-number-range-input name="age" [(ngModel)]="qualifiedInterval.criteria['age']"></hw-number-range-input>
            </hw-form-item>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </hw-flex-editable-table>
</form>
